import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export const CheckoutShell = ({ title, subtitle, children }) => (
  <div className="bg-white min-h-screen">
    <section className="bg-charcoal pt-40 pb-20">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Link
          to="/services"
          data-testid="checkout-back-link"
          className="font-display text-white/50 hover:text-sky-brand text-sm inline-flex items-center gap-2 mb-6 transition-colors"
        >
          <ChevronLeft size={16} /> Back to services
        </Link>
        <h1 className="font-display text-4xl md:text-5xl font-bold text-white tracking-tight">{title}</h1>
        {subtitle && <p className="font-body text-white/60 mt-4 text-lg">{subtitle}</p>}
      </div>
    </section>
    <section className="py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-6 md:px-12">{children}</div>
    </section>
  </div>
);

export const SummaryCard = ({ name, price, unit, items = [] }) => (
  <div className="rounded-[2rem] bg-charcoal text-white p-8 md:p-10" data-testid="order-summary">
    <div className="font-display text-sm uppercase tracking-widest text-sky-brand">Order summary</div>
    <div className="flex items-baseline justify-between mt-5">
      <span className="font-display text-2xl font-semibold">{name}</span>
      <span className="font-display text-3xl font-bold text-sky-brand">
        ${price} <span className="text-sm text-white/50 font-normal">{unit}</span>
      </span>
    </div>
    {items.length > 0 && (
      <ul className="mt-6 space-y-2 border-t border-white/10 pt-6">
        {items.map((it, i) => (
          <li key={i} className="font-body text-white/70 text-sm flex justify-between">
            <span>{it.label}</span>
            {it.value && <span className="text-white/90">{it.value}</span>}
          </li>
        ))}
      </ul>
    )}
  </div>
);

export const Field = ({ label, ...props }) => (
  <div>
    <label className="font-display text-sm font-medium text-charcoal block mb-2">{label}</label>
    <input
      {...props}
      className="w-full bg-gray-50 border border-gray-200 focus:border-sky-brand focus:ring-2 focus:ring-sky-brand/20 outline-none px-6 py-4 rounded-2xl font-body text-charcoal placeholder:text-gray-400 transition-all"
    />
  </div>
);

export default CheckoutShell;
